import { Navigate, Route, Routes } from "react-router-dom";

import AdTabs from "./components/ad-tabs";
import Edit from "./edit";
import Settings from "./settings";
import Distribution from "./distribution";

export default function Ad({ job, setJob, posts, setPosts }) {
  return (
    <div className="flex flex-col h-full">
      <AdTabs />
      <div className="flex-1 overflow-auto">
        <Routes>
          <Route index element={<Navigate to="job" replace />} />
          <Route path="job/*" element={<Edit job={job} setJob={setJob} />} />
          <Route path="application" element={<Settings job={job} setJob={setJob} />} />
          <Route path="distribution/*" element={<Distribution job={job} setJob={setJob} posts={posts} setPosts={setPosts} />} />
        </Routes>
      </div>
    </div>
  );
}
